module.exports = __webpack_public_path__ + "static/media/icon_words-to-pages.6c6f5b26.svg";